export default __webpack_public_path__ + "static/media/serviceNotFound.26a010e0.svg";